import React from 'react';
import PropTypes from 'prop-types';

function DatapointsExportModalHeader(props) {
  const { parentParams, selectedDatapoints } = props;
  const { context } = parentParams; // replaceCitations
  const { count } = selectedDatapoints;

  return (
    <div className="exportModal__header">
      <h4>
        Export
        <span className="text-lowercase">{context}</span>
        {!!count && <span>{count}</span>}
      </h4>
    </div>
  );
}

DatapointsExportModalHeader.propTypes = {
  parentParams: PropTypes.object,
  selectedDatapoints: PropTypes.object,
};

export default DatapointsExportModalHeader;
